module.exports = __webpack_public_path__ + "static/media/trip-advisor-review-1.38f065d4.png";